<h2 mat-dialog-title>Trash tasks?</h2>

<mat-dialog-content> Trash {{ tasks.length }} tasks? </mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button (click)="cancel()">Cancel</button>
  <button mat-raised-button color="primary" (click)="accept()">Trash</button>
</mat-dialog-actions>
